import Map from "./Components/Map";
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Loading from "./UI/Loading";
import Sidebar from "./Components/Sidebar";
import "./App.css";
function App() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isClick, setIsClick] = useState(false);
  const [event, setEvent] = useState({
    id: 12,
    icon: "emojione-monotone:snow-capped-mountain",
    color: "maroon",
  });
  const eventCategories = [
    // https://eonet.gsfc.nasa.gov/api/v2.1/categories
    {
      id: 10,
      events: "Severe Storms",
      icon: "fluent:weather-thunderstorm-20-filled",
      color: "lightblue",
    },
    {
      id: 12,
      events: "Volcanoes",
      icon: "emojione-monotone:snow-capped-mountain",
      color: "maroon",
    },
    {
      id: 8,
      events: "Wildfires",
      icon: "mdi:fire-alert",
      color: "red",
    },
  ];
  const dataFilter = data.filter((data) => {
    if (data.idEvents) return data.idEvents == event.id;
  });

  const fethData = async () => {
    setLoading(true);
    const response = await fetch("https://eonet.gsfc.nasa.gov/api/v2.1/events");
    const datas = await response.json();
    let loadedData = [];
    datas.events.map((data) => {
      loadedData.push({
        idEvents: data.categories[0].id,
        lat: data.geometries[0].coordinates[1],
        lng: data.geometries[0].coordinates[0],
        title: data.title,
        link: data.sources[0].url,
      });
      // }
    });

    setData(loadedData);
    setLoading(false);
  };

  useEffect(() => {
    fethData();
  }, []);

  const eventCategoriesHandler = (id, icon, color) => {
    setEvent({ id: id, icon: icon, color: color });
    // alert("hiiii");
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="App">
      <header>
        <div className="icon">
          <Icon
            icon={isClick ? "iconoir:cancel" : "ci:hamburger"}
            onClick={() => {
              setIsClick((click) => !click);
            }}
          />
        </div>

        <div className="nama">Data Of Natural events Powered By Nasa</div>
        <ul>
          {eventCategories.map((e) => {
            return (
              <li
                className={event.id == e.id ? "active" : ""}
                onClick={() =>
                  setEvent({ id: e.id, icon: e.icon, color: e.color })
                }
              >
                <Icon icon={e.icon} />
                {e.events}
              </li>
            );
          })}
        </ul>
      </header>
      <div className="main">
        <section className={`sidebar ${isClick ? "sidebarOpen" : ""}`}>
          <Sidebar
            data={dataFilter}
            eventId={event.id}
            eventCategories={eventCategories}
            eventCategoriesHandler={eventCategoriesHandler}
          />
        </section>
        <section className="googleMap">
          <Map data={dataFilter} icon={event} />
        </section>
      </div>
    </div>
  );
}

export default App;
